/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DoctorEspecialty from './doctor-especialty';
import DoctorEspecialtyDetail from './doctor-especialty-detail';
import DoctorEspecialtyUpdate from './doctor-especialty-update';
import DoctorEspecialtyDeleteDialog from './doctor-especialty-delete-dialog';

const DoctorEspecialtyRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DoctorEspecialty />} />
    <Route path="new" element={<DoctorEspecialtyUpdate />} />
    <Route path=":id">
      <Route index element={<DoctorEspecialtyDetail />} />
      <Route path="edit" element={<DoctorEspecialtyUpdate />} />
      <Route path="delete" element={<DoctorEspecialtyDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DoctorEspecialtyRoutes;
